// @ts-nocheck
import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import { setupInterceptorsTo } from "../../Componentes/API/AxiosBuilder";
import { RUTA_API_USUARIOS } from "../../Contantes/Constantes";
import { useBody } from "../../Body/state/BodyContext";
import { useUsuarios } from "../State/UsuarioContext";

export default function ModalDarAltaUsuario({ open, onClose, uid, ...props }) {
    const axiosInstance = setupInterceptorsTo(axios.create());
    const { setSuccess, setMessage } = useBody();
    const { getAltasPendientes } = useUsuarios();

    const [loading, setLoading] = useState(false);

    const peticionAltaDefinitiva = async () => {
        setLoading(true);
        try {
            await axiosInstance({
                method: 'POST',
                url: `${RUTA_API_USUARIOS}/ldap/users/${uid}`
            });
            setSuccess("Se ha dado de alta el usuario " + uid + " satisfactoriamente");
            onClose();
            getAltasPendientes();
        } catch (error) {
            if (error.response?.status === 409)
                setMessage(error.response.data);
            else
                setMessage("Hubo un error al querer dar de alta al usuario " + uid + " (Código de error: 00044)");
        } finally {
            setLoading(false);
        }
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
                sx: {
                    p: 2,
                    borderRadius: 2,
                    minWidth: 320
                },
            }}
        >
            <DialogContent sx={{ textAlign: 'center', pb: 5 }}>
                <DialogContentText id="alert-dialog-description" sx={{ fontSize: 16 }}>
                    ¿Desea dar de alta al usuario <b>{uid}</b>?
                </DialogContentText>
            </DialogContent>

            <DialogActions sx={{ justifyContent: 'center', gap: 2, pb: 2 }}>
                <Button
                    onClick={onClose}
                    disabled={loading}
                    sx={{ color: '#b0003a' }}
                >
                    No, cancelar
                </Button>

                <Button
                    color="primary"
                    variant="contained"
                    onClick={peticionAltaDefinitiva}
                    disabled={loading}
                    autoFocus
                    sx={{
                        backgroundColor: '#b0003a',
                        '&:hover': { backgroundColor: '#920030' },
                        minWidth: 120
                    }}
                    startIcon={loading ? <CircularProgress size={18} color="inherit" /> : null}
                >
                    {loading ? 'Procesando...' : 'Sí, confirmar'}
                </Button>
            </DialogActions>
        </Dialog>

    );
}
